import React, { memo, useEffect } from 'react';
import { Placeholder, useSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { HbtSitecoreContextType } from 'Foundation/HydrateSitecoreContext';
import HbtDashboardPlaceholderProps from './types';
import { pathNames } from 'Constants/pathNames';

const HbtDashboardPlaceHolderComponent: React.FC<HbtDashboardPlaceholderProps> = ({
  rendering
}: HbtDashboardPlaceholderProps) => {
  const sitecoreContextFactory = useSitecoreContext();
  const sitecoreContext = sitecoreContextFactory?.sitecoreContext as HbtSitecoreContextType;

  useEffect(() => {
    if (sitecoreContext.isServicingSite) {
      window.location.href = pathNames.servicing;
    }
  }, [sitecoreContext.isServicingSite]);

  if (!sitecoreContext.isPortfolioSite) {
    return null;
  }

  return <Placeholder name="hbt-v2-dashboard" rendering={rendering} />;
};

export default memo(HbtDashboardPlaceHolderComponent);
